import { opensTurn } from '@littlebird/ui-utils';

import { isSystemApp, normalizeAppKey } from './capturedAppIcons';

import type { Message as TMessage } from '@littlebird/sdk';

export function collectTurnApps(
  message: TMessage,
  threadMessages: readonly TMessage[]
): string[] {
  const finalIndex = threadMessages.findIndex((m) => m.id === message.id);
  if (finalIndex === -1) {
    return message.contextAppsUsed
      .filter((a) => !isSystemApp(a))
      .map((a) => a.trim());
  }

  const seen = new Set<string>();
  const apps: string[] = [];
  for (let i = finalIndex; i >= 0; i--) {
    const m = threadMessages[i];
    if (opensTurn(m)) break;
    for (const app of m.contextAppsUsed) {
      if (isSystemApp(app)) continue;
      const key = normalizeAppKey(app);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      apps.push(app.trim());
    }
  }
  return apps;
}
